import React from 'react';

import SmsControls from '../components/SmsControls';
import { useFeatureEnables } from '../dataProviders';
import { makeBtStyles, Theme } from '../Theme';

import Card, { CardSection } from './Card';



const useStyles = makeBtStyles( (theme: Theme) => ({
  root: {
    borderLeft: '3px solid #222222',
    '&:empty': {
      display: 'none'
    }
  }
}));


export default function SmsCard({ className='' }) {
  const classes = useStyles();
  const { showSms } = useFeatureEnables();

  if( !showSms ) {
    return null;
  }

  return (
    <Card className={`${classes.root} ${className}`}>
      <CardSection>
        <SmsControls />
      </CardSection>
    </Card>
  );
}